export default __webpack_public_path__ + "static/media/linkedin.cbd326bd.svg";